import useViewShow from "@/domains/hotel/hooks/useViewShow";
import HotelCashierContainer from "@/domains/hotel/containers/HotelCashierContainer";
import HotelIntercomContainer from "@/domains/hotel/containers/HotelIntercomContainer";
import HotelRoomSelectContainer from "@/domains/hotel/containers/HotelRoomSelectContainer";

export default function HotelContainer() {
  const { showCashier, showElevator, showIntercom, hotelId, idInRoom } = useViewShow();

  return (
    <>
      {showCashier && hotelId && <HotelCashierContainer hotelId={hotelId} />}
      {showElevator && hotelId && <HotelRoomSelectContainer hotelId={hotelId} />}
      {showIntercom && idInRoom && <HotelIntercomContainer estateId={idInRoom} />}
    </>
  );
}
